// extracted by mini-css-extract-plugin
export default {"attributes":"EI5jtPBynuy9i1s0dftU"};